import { graphql } from '@/generated/gql';

export const RISK_DETAIL_QUERY = graphql(/* GraphQL */ `
  query RiskDetail($id: UUID!) {
    cataclysm {
      risk(id: $id) {
        id
        name
        description
      }
    }
  }
`);
